export const calculateWatchdogNextValue = (prev: number) => (prev >> 1) ^ ((prev & 1) * 0x977f)
